import { Box, Chip, Skeleton } from '@mui/material';
import { FC } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
	timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { selectOrderDetails, selectOrderDetailsLoading } from 'redux/reducers/euDdp/selectors';
import { EasCard } from 'ui/EasCard';

export const ShipmentTimeLine: FC = () => {
	const orderIsLoading = useSelector(selectOrderDetailsLoading);
	const order = useSelector(selectOrderDetails);
	const timeLine = order?.order_history;

	return (
		<Box>
			{order && !orderIsLoading ? (
				<Box sx={{ maxWidth: '100vw', overflowX: 'auto', width: '100%' }}>
					<Box sx={{ minWidth: '420px', width: '100%' }}>
						<EasCard id="eu-ddp-order-shipment-timeline" title="Shipment Timeline">
							<Timeline
								sx={{
									m: 0,
									p: 0,
									[`& .${timelineOppositeContentClasses.root}`]: {
										flex: '1 0 0',
										maxWidth: '220px',
									},
									[`& .MuiTimelineItem-root`]: {
										minHeight: '50px',
									},
								}}
								position="right"
							>
								{timeLine?.map((item, index) => (
									<TimelineItem key={item.status_name} color="primary">
										<TimelineOppositeContent
											color="textSecondary"
											sx={{ fontSize: '0.8rem', m: 0, pl: 0, alignItems: 'left' }}
										>
											{!!timeLine?.[index]?.status_date &&
												DateTime.fromISO(timeLine?.[index]?.status_date).toFormat(
													'yyyy-MM-dd, HH.mm',
												)}
										</TimelineOppositeContent>
										<TimelineSeparator>
											<TimelineDot color={timeLine?.[index]?.status_date ? 'primary' : 'grey'} />
											{index !== (timeLine?.length ?? 0) - 1 && (
												<TimelineConnector
													sx={{
														backgroundColor: timeLine?.[index]?.status_date ? 'primary.main' : '',
													}}
												/>
											)}
										</TimelineSeparator>
										<TimelineContent sx={{ pr: 0 }}>
											<Chip
												label={item.status_name}
												color={timeLine?.[index]?.status_date ? 'primary' : 'default'}
												size="small"
												sx={{
													fontSize: '.7rem',
													height: '20px',
													bgcolor: timeLine?.[index]?.status_date ? 'primary.light' : 'grey.300',
													color: '#000000a5',
												}}
											/>
										</TimelineContent>
									</TimelineItem>
								))}
							</Timeline>
						</EasCard>
					</Box>
				</Box>
			) : (
				<Skeleton variant="rectangular" height="500px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</Box>
	);
};
